import { InfoTokenService } from './../../services/infoUser/info-user.service';
import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  NavigationEnd,
  Router,
} from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Modules, Notifications } from '../../interfaces';
import {
  IPermissions,
  ModulesMangosI,
} from '../../interfaces/modules-mango.interface';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { IDataToken, IUser } from '../../interfaces/toolbar/toolbar.interface';
import { RolesUserService } from '../../services/roles-user/roles-user.service';
import { IPkSk } from '../../interfaces/versions.interface';

@Component({
  selector: 'mg-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnChanges, OnDestroy {
  @Input() version: string = '0.0.0';
  @Input() listSidebar: Modules[] = [];
  @Input() notification!: Notifications;
  @Input() url: string = '';
  @Input() loading: boolean = true;
  @Input() publicPaths: string[] = [];
  @Input() showModules: boolean = true;

  @Input() ids!: IPkSk;
  modulesMango: IPermissions = {} as IPermissions;
  modules: ModulesMangosI[] = [];
  paths: string[] = [];
  status = false;
  viewNotifications: boolean = false;
  subscriptionRoute?: Subscription;
  stateAuth: boolean = false;
  user!: IUser;
  destroy$ = new Subject<void>();
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthenticationService,
    private roleUserService: RolesUserService,
    private infoTokensService: InfoTokenService
  ) {}

  ngOnInit() {
    this.validateRoute();
    this.roleUserService.getPermissions
      .pipe(takeUntil(this.destroy$)) //I keep modulesMango updated
      .subscribe((modulesMango) => (this.modulesMango = modulesMango));
  }

  ngOnChanges(changes: SimpleChanges): void {
    localStorage.setItem('url', this.url);
    this.paths = this.publicPaths || [];
    this.paths = [...this.paths, 'login', 'register', 'forgot-password'];
  }
  statusSidebar(status: boolean) {
    this.status = status;
  }

  validateRoute() {
    this.auth.setUrl(this.url);
    this.subscriptionRoute = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.route.snapshot),
        map((route: ActivatedRouteSnapshot) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .subscribe((route: ActivatedRouteSnapshot) => {
        const url = route.url[0]?.path || '/login'; //valid path to show sidebar and toolbar
        this.paths.includes(url)
          ? (this.stateAuth = false)
          : (this.stateAuth = true);
        this.refreshModules();
      });
  }

  async refreshModules() {
    if (this.stateAuth && !this.modulesMango.user) {
      //I request roles when the user is authenticated
      this.getUser();
      const resp = await this.auth.getInfoRoles(this.url);
      this.modulesMango = resp;
      this.roleUserService.setPermissions(resp);
      this.modules = await this.auth.getModules(this.url);
    } else if (!this.modulesMango.user) {
      this.modulesMango = {} as IPermissions;
    }
  }

  getUser() {
    const currentUser: IDataToken = this.infoTokensService.getDataToken();
    this.user = {
      ...this.user,
      fullName: this.infoTokensService.getName(),
    };
    if (currentUser) {
      this.auth
        .getUser(
          this.url,
          `${currentUser.username}:users`,
          `${currentUser.username}:current`
        )
        .subscribe(
          ({ data }) => {
            this.user = data;
            this.infoTokensService.setUserData(this.user);
            this.infoTokensService.setName(data.fullName);
          },
          (error) => console.error(error)
        );
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscriptionRoute?.unsubscribe();
  }
}
